//NEW: UI_REVAMP
import { Flex, Text } from '@chakra-ui/react';
import ImgComp from '../../utils/ImgComp';
import GradientBox from '../box/GradientBox';

const PlayerProfileCard = ({ userName, balance, onClick }) => {
	return (
		<>
			<GradientBox>
				<Flex
					bgGradient='linear-gradient(180deg, #FFF 0%, #E5EDF9 100%), #D6E7FF'
					justifyContent='space-between'
					alignItems='center'
					borderRadius='inherit'
					p={4}
				>
					<Flex alignItems='center' gap={2}>
						<ImgComp
							svgName='avatar'
							width={{ base: '40px', lg: '84px' }}
							height={{ base: '40px', lg: '84px' }}
						/>
						<Text
							color='#111111'
							fontSize={{ base: '20px' }}
							fontWeight={600}
							textTransform='capitalize'
						>
							{userName}
						</Text>
					</Flex>
					<Flex flexDirection='column' textAlign='center'>
						<Text color='#111111' fontSize={{ base: '12px', lg: '14px' }} fontWeight={400}>
							Balance Amount
						</Text>
						<Text
							bgGradient='linear-gradient(180deg, #01A13D 0%, #09632B 100%)'
							bgClip='text'
							sx={{
								WebkitBackgroundClip: 'text',
								WebkitTextFillColor: 'transparent',
							}}
							fontWeight={600}
							fontSize={{ base: '20px', lg: '22px' }}
						>
							PHP {balance}
						</Text>
					</Flex>
				</Flex>
			</GradientBox>

			{/* Development use only: hidden from production users */}
			{sessionStorage.getItem('isThirdPartyLogin') === 'false' && (
				<Flex
					onClick={onClick}
					justifyContent='space-between'
					alignItems='center'
					borderWidth='1px'
					borderRadius='8px'
					borderColor='blue.200'
					backgroundColor='blue.200'
					padding='3px 10px'
					marginY='10px'
					cursor='pointer'
					userSelect='none'
				>
					<Text fontSize={{ base: '14px', lg: '18px' }} fontWeight={{ base: '500', lg: '600' }}>
						Change Password
					</Text>
					<ImgComp svgName='right-arrow' />
				</Flex>
			)}
		</>
	);
};

export default PlayerProfileCard;
